import React from 'react';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/905372101452', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 hover:scale-110 text-white rounded-full shadow-2xl transition-all duration-300 group"
      aria-label="WhatsApp ile iletişime geç"
    >
      <img 
        src="https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/d464ij3k_thumbnail.png" 
        alt="WhatsApp" 
        className="w-20 h-20 animate-pulse"
      />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Bize WhatsApp'tan Yazın
      </span>
    </button>
  );
};

export default WhatsAppButton;